import { render, staticRenderFns } from "./NamingNBranding-tijuana.vue?vue&type=template&id=73fb4e62&scoped=true"
import script from "./NamingNBranding-tijuana.vue?vue&type=script&lang=js"
export * from "./NamingNBranding-tijuana.vue?vue&type=script&lang=js"
import style0 from "./NamingNBranding-tijuana.vue?vue&type=style&index=0&id=73fb4e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb4e62",
  null
  
)

export default component.exports